
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-plans",
      function () {
        return require("private-next-pages/api-plans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-plans"])
      });
    }
  